<script setup lang="ts">
const colorMode = useColorMode()

const color = computed(() => colorMode.value === 'dark' ? '#1b1718' : 'white')

// Start proactive session refresh scheduler
const { scheduleRefresh } = useSessionRefresh()
// Schedule initial refresh check (will only activate if authenticated with valid expiresAt)
onMounted(() => {
  scheduleRefresh()
})

useHead({
  meta: [
    { charset: 'utf-8' },
    { name: 'viewport', content: 'width=device-width, initial-scale=1' },
    { key: 'theme-color', name: 'theme-color', content: color }
  ],
  link: [
    { rel: 'icon', href: '/favicon.ico' }
  ],
  htmlAttrs: {
    lang: 'en'
  }
})

const title = 'A55 Merchant Platform'
const description = 'Manage your transactions, refunds and settlements.'

useSeoMeta({
  title,
  description,
  ogTitle: title,
  ogDescription: description,
  ogImage: 'https://i0.wp.com/a55.academy/wp-content/uploads/2023/01/Asset-1.png',
  twitterImage: 'https://i0.wp.com/a55.academy/wp-content/uploads/2023/01/Asset-1.png',
  twitterCard: 'summary_large_image'
})
</script>

<template>
  <UApp>
    <NuxtLoadingIndicator />

    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </UApp>
</template>
